// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "stylesheets/" + chunkId + "." + "1fb0bf9c86" + ".css";
};